import { computed } from 'mobx'
import { ALIGNMENT } from 'prose-core'
import { type EditorView } from 'prosemirror-view'
import { useContext } from 'react'

import { useEditorView } from 'common/Prose/EditorProvider/hooks/useEditorView'
import { ButtonHook } from 'common/Prose/Toolbar/Types'
import { AlmanacEditorStateContext } from 'stores/EditorState'

export function useAlignButtonToggle(type: ALIGNMENT): ButtonHook {
  const view = useEditorView()
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
  const { activeAlignments } = useContext(AlmanacEditorStateContext)!

  const active = computed(() => {
    const singleAlignment = activeAlignments.size === 1
    return singleAlignment && activeAlignments.has(type)
  }).get()

  return { active, handleClick: changeAlignment(view, type) }
}

export const changeAlignment = (view: EditorView, alignment: NonNullable<ALIGNMENT>) => () => {
  const {
    doc,
    selection: { ranges },
    tr,
  } = view.state

  for (let {
    $from: { pos: from },
    $to: { pos: to },
  } of ranges) {
    doc.nodesBetween(from, to, (node, pos) => {
      if (node.type.groups.includes('textWrap')) {
        tr.setNodeMarkup(pos, node.type, { ...node.attrs, alignment })
      } else if (node.type.name === 'image') {
        tr.setNodeMarkup(pos, node.type, { ...node.attrs, float: alignment })
      }

      return true
    })
  }

  view.dispatch(tr)
  view.focus()
}
